<template>
   <div :id="domId || uid" :style="style" />
</template>

<script>
import { isObject, guid, addUnit, isVid } from './libs/function'
import props from './props.js'

export default {
  name: 'CCVue',
  mixins: [props],
  data() {
    return {
      uid: guid(6),
      player: null,
    }
  },
  computed:{
    style(){
      return {
        width:addUnit(this.width),
        height:addUnit(this.height),
        position:'relative',
        'z-index':'1'
      }
    }
  },
  watch: {
    /**
     * 监听vid变化，如果符合要求，则触发视频切换
     */
    vid: {
      handler(newVal,oldVal) {
        if(!newVal){
          if(oldVal){
            this.$message.error('视频为空！')
            this.playerDestroy()
          }
        }else if(isVid(newVal)){
           this.$nextTick(()=>{
            this.init()
          })
        }else{
          this.$message.error('视频错误！')
          this.playerDestroy()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.setPlayerCallBack()
  },
  mounted() {
    
  },
  beforeDestroy() {
    this.playerDestroy()
  },
  methods: {
    // CC点播的回调是全局的，所以需要全局暴露这些函数
    setPlayerCallBack() {
      // 播放器js文件加载完成时回调
      window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded
      // 播放器初始化完成即将播放时回调
      window.on_CCH5player_ready = this.onPlayerReady
      // 播放时回调
      window.on_CCH5player_play = this.onPlayerPlay
      // 播放位置发生改变时回调
      window.on_player_timeupdate = this.onPlayerTimeUpdate
      // 暂停播放时回调
      window.on_CCH5player_pause = this.onPlayerPause
      // 播放结束时回调
      window.on_CCH5player_ended = this.onPlayerEnded
    },

    // 初始化创建播放器
    init() {
      if (!window.ccH5PlayerJsLoaded) {
        console.error('CCPlayer提示：请引入H5插件：https://p.bokecc.com/player?newversion=true')
        return
      }
      if (!this.player) {
        const options = this.getOptions()
        this.player = window.createCCH5Player(options)
      } else {
        this.changeVideo()
      }
    },
    onCCH5PlayerLoaded() {
      // window.ccH5PlayerJsLoaded = true
    },
    /**
     * 播放器初始化完成
     * @param {Object} obj 包含videoElement、container、vid三个属性，分别指当前视频对象，当前播放器容器，当前视频id
     */
    onPlayerReady(obj) {
      // console.log('播放器初始化完成')
      this.$emit('onReady', obj)
      if (this.autoStart) {
        this.player.play()
      }
    },
    /**
     * 播放时
     * @param {video} 视频节点对象
     * @param {vid} 视频id
     */
    onPlayerPlay(video, vid) {
      // console.log('视频开始播放')
      // console.log(vid,666)
      this.$emit('onPlay', vid)
    },
    /**
     * 暂停播放时
     * @param {video} 视频节点对象
     * @param {vid} 视频id
     */
    onPlayerPause(video, vid) {
      this.$emit('onPause', vid)
    },
    /**
     * 播放位置发生改变
     * @param {currentTime} 当前播放时间
     * @param {vid} 视频id
     */
    onPlayerTimeUpdate(currentTime, vid) {
      this.$emit('onTimeUpdate', currentTime, vid)
    },
    /**
     * 播放结束时
     * @param {vid} 视频id
     */
    onPlayerEnded(video, vid) {
      // console.log('视频已播放完成')
      this.$emit('onEnded', vid)
    },
    // 切换视频
    changeVideo(vid, custom = {}) {
      vid = vid || this.vid
      // 组件配置和传入的进行合并,优先传入的
      const options = this.getOptions(custom)
      this.player.changeVideo(vid, options)
    },
    // 视频时长（秒）
    getDuration() {
      let duration = 0
      if(this.player && this.player.getDuration){
         duration = this.player.getDuration()
         duration = Math.floor(duration)
      }
      return duration || 0
    },
    // 当前视频播放时间（秒）
    getCurrentTime() {
      let current = 0
      if(this.player && this.player.getPosition){
         current = this.player.getPosition()
         current = Math.floor(current)
      }
      return current || 0
    },
     // 视频播放
    play() {
      if(this.player && this.player.play){
        this.player.play()
      }
    },
     // 视频暂停
    pause() {
      if(this.player && this.player.pause){
        this.player.pause()
      }
    },
    /**
     * 销毁播放器
     */
    playerDestroy() {
      if (this.player && this.player.destroy) {
        this.player.destroy()
        this.player = null
        console.warn('销毁成功！')
      } else {
        console.error('播放器销毁失败，请检查player对象！')
      }
      this.$emit('onPause')
    },
    /**
     * 获取最终配置
     */
    getOptions(custom) {
      custom = isObject(custom) ? custom : {}
      const parentNode = '#' + (this.domId || this.uid)
      const { vid, width, height, autoStart, dragEnable, rateEnable, startTime } = this.$props
      const options = {
        siteid: '0F8D4F24CBBD8509',
        parentNode,
        vid: custom.vid || vid,
        width: width,
        height: height,
        autoStart: custom.autoStart || autoStart,
        progressbar_enable: custom.dragEnable || dragEnable ? 1 : 0,
        // banDrag: !(custom.dragEnable || dragEnable),
        rate_allow_change: custom.rateEnable || rateEnable,
        watchStartTime: custom.startTime || startTime,
        closeHistoryTime:1,
        closeResizeCheckPlaySafe:true
      }
      return options
    },
    addUnit,
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/YcyPlayer/src/cc.vue